/** @jsx */

/** @jsxFrag */
import { css } from '@emotion/react';

import * as React from 'react';
import { useContext } from 'react';

import { Divider, Skeleton, Typography2 } from '@coursera/cds-core';

import { ProfileContext } from 'bundles/account-profile/components/recruiting-profile-viewer/ProfileContextProvider';
import HighlightsSectionCredentials from 'bundles/account-profile/components/recruiting-profile-viewer/components/highlights/HighlightsSectionCredentials';
import HighlightsSectionTags from 'bundles/account-profile/components/recruiting-profile-viewer/components/highlights/HighlightsSectionTags';
import shouldShowHighlightsEducationTag from 'bundles/account-profile/components/recruiting-profile-viewer/components/highlights/shouldShowHightlightGraduationTag';

const styles = {
  divider: () => css`
    margin: var(--cds-spacing-200) 0;
  `,
};

export const HighlightsSectionBodyPlaceholder = () => {
  return (
    <div role="status">
      <Typography2 component="p" variant="bodySecondary">
        <Skeleton variant="rect" width="50%" />
      </Typography2>
      <Divider color="light" css={styles.divider} />
      <Typography2 component="p" variant="bodySecondary">
        <Skeleton variant="rect" height={50} />
      </Typography2>
    </div>
  );
};

export const HighlightsSectionBody = () => {
  const { profileState, isProfileLoading } = useContext(ProfileContext);

  // Loading state
  if (isProfileLoading) {
    return <HighlightsSectionBodyPlaceholder />;
  }

  const educationHistory = profileState?.educationHistory;
  const { completedProfessionalCertificates, completedSpecializations } = profileState?.courseraHistory ?? {
    completedProfessionalCertificates: [],
    completedSpecializations: [],
  };

  const showDivider =
    shouldShowHighlightsEducationTag(educationHistory) &&
    (completedProfessionalCertificates.length > 0 || completedSpecializations.length > 0);

  return (
    <>
      <HighlightsSectionTags />
      {showDivider && <Divider data-testid="highlights-section-divider" color="light" css={styles.divider} />}
      <HighlightsSectionCredentials />
    </>
  );
};

export default HighlightsSectionBody;
